import { render, staticRenderFns } from "./consumption.vue?vue&type=template&id=d3cffd82&"
import script from "./consumption.vue?vue&type=script&lang=js&"
export * from "./consumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports